document.addEventListener('DOMContentLoaded', function () {
  // Clear Shopify contact success query params so refresh never reopens thank-you.
  try {
    var url = new URL(window.location.href);
    if (url.searchParams.has('contact_posted') || url.searchParams.has('customer_posted')) {
      url.searchParams.delete('contact_posted');
      url.searchParams.delete('customer_posted');
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    }
  } catch (e) {}

  document.querySelectorAll('.ask-an-expert__legacy-blocks input, .ask-an-expert__legacy-blocks textarea, .ask-an-expert__legacy-blocks select').forEach(function (el) {
    el.disabled = true;
    el.removeAttribute('required');
  });

  document.querySelectorAll('side-drawer.ask-an-expert-drawer').forEach(function (drawer) {
    var overlay = drawer.querySelector('.drawer__overlay, [id^="Drawer-Overlay-"]');
    if (overlay) {
      var clean = overlay.cloneNode(true);
      overlay.parentNode.replaceChild(clean, overlay);
      drawer.overlay = clean;
      clean.addEventListener('click', function (e) {
        if (e.target !== clean) return;
        drawer.close();
      });
    }
  });

  document.querySelectorAll('[data-contact-form-type="ask-an-expert"]').forEach(function (wrapper) {
    var form = wrapper.querySelector('form');
    var submit = wrapper.querySelector('[data-aae-submit]');
    var intro = wrapper.querySelector('[data-aae-intro]');
    var formBody = wrapper.querySelector('[data-aae-form-body]');
    var success = wrapper.querySelector('[data-aae-success]');
    var drawer = wrapper.closest('side-drawer');

    if (!form || !submit) return;

    submit.disabled = false;
    submit.removeAttribute('aria-disabled');
    wrapper.classList.remove('ask-an-expert--disabled');

    function showForm() {
      if (intro) intro.hidden = false;
      if (formBody) formBody.hidden = false;
      if (success) success.hidden = true;
    }

    function showSuccess() {
      if (intro) intro.hidden = true;
      if (formBody) formBody.hidden = true;
      if (success) success.hidden = false;
    }

    // Always start on the form after load/refresh — never auto-open thank-you.
    showForm();

    if (drawer) {
      drawer.querySelectorAll('[data-aae-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          showForm();
          if (typeof drawer.close === 'function') drawer.close();
        });
      });

      // When drawer closes by overlay/X, restore form for next open.
      var closeBtn = drawer.querySelector('.drawer__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          showForm();
        });
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
        return;
      }

      var body = new FormData(form);
      var action = form.getAttribute('action') || window.location.pathname;

      form.reset();
      showSuccess();

      fetch(action, {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html,application/xhtml+xml',
        },
        redirect: 'manual',
      }).catch(function () {
        /* no-op */
      });
    });
  });
});
